var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6339 10.2762C17.122 9.75545 17.122 8.91123 16.6339 8.39052C16.1458 7.86983 15.3543 7.86983 14.8661 8.39052L10.75 12.7811L9.13389 11.0572C8.64573 10.5365 7.85428 10.5365 7.36611 11.0572C6.87796 11.5779 6.87796 12.4222 7.36611 12.9428L9.86612 15.6095C10.3543 16.1302 11.1457 16.1302 11.6339 15.6095L16.6339 10.2762Z",
    fill: "#1DA735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.0c8511eb7e5f5f6d99a34bca4b25661f.svg";
export { ForwardRef as ReactComponent };